import React from "react";
import { createStyles } from "@material-ui/styles";
import { Button, withStyles } from "@material-ui/core";
const styles = createStyles((theme) => ({
  outerDiv: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #EEEEEE",
    borderRadius: 8,
    width: 77,
    height: 40,
    marginRight: 5,
    float: "left",
    textRransform: "lowercase",
  },
}));

function ButtonExport(props) {
  const { classes } = props;
  return <button className={classes.outerDiv}>Export</button>;
}
export default withStyles(styles)(ButtonExport);
